export interface Currency {
  code: string;
  name: string;
  symbol: string;
  country: string;
  countryCode: string;
}

export const currencies: Currency[] = [
  {
    code: "USD",
    name: "US Dollar",
    symbol: "$",
    country: "United States",
    countryCode: "US",
  },
  {
    code: "EUR",
    name: "Euro",
    symbol: "€",
    country: "European Union",
    countryCode: "EU",
  },
  {
    code: "GBP",
    name: "British Pound",
    symbol: "£",
    country: "United Kingdom",
    countryCode: "GB",
  },
  {
    code: "JPY",
    name: "Japanese Yen",
    symbol: "¥",
    country: "Japan",
    countryCode: "JP",
  },
  {
    code: "AUD",
    name: "Australian Dollar",
    symbol: "A$",
    country: "Australia",
    countryCode: "AU",
  },
  {
    code: "CAD",
    name: "Canadian Dollar",
    symbol: "C$",
    country: "Canada",
    countryCode: "CA",
  },
  {
    code: "CHF",
    name: "Swiss Franc",
    symbol: "Fr",
    country: "Switzerland",
    countryCode: "CH",
  },
  {
    code: "CNY",
    name: "Chinese Yuan",
    symbol: "¥",
    country: "China",
    countryCode: "CN",
  },
  {
    code: "INR",
    name: "Indian Rupee",
    symbol: "₹",
    country: "India",
    countryCode: "IN",
  },
  {
    code: "SGD",
    name: "Singapore Dollar",
    symbol: "S$",
    country: "Singapore",
    countryCode: "SG",
  },
  {
    code: "NZD",
    name: "New Zealand Dollar",
    symbol: "NZ$",
    country: "New Zealand",
    countryCode: "NZ",
  },
  {
    code: "MXN",
    name: "Mexican Peso",
    symbol: "$",
    country: "Mexico",
    countryCode: "MX",
  },
  {
    code: "HKD",
    name: "Hong Kong Dollar",
    symbol: "HK$",
    country: "Hong Kong",
    countryCode: "HK",
  },
  {
    code: "BRL",
    name: "Brazilian Real",
    symbol: "R$",
    country: "Brazil",
    countryCode: "BR",
  },
  {
    code: "RUB",
    name: "Russian Ruble",
    symbol: "₽",
    country: "Russia",
    countryCode: "RU",
  },
  {
    code: "KRW",
    name: "South Korean Won",
    symbol: "₩",
    country: "South Korea",
    countryCode: "KR",
  },
  {
    code: "TRY",
    name: "Turkish Lira",
    symbol: "₺",
    country: "Turkey",
    countryCode: "TR",
  },
  {
    code: "ZAR",
    name: "South African Rand",
    symbol: "R",
    country: "South Africa",
    countryCode: "ZA",
  },
  {
    code: "SEK",
    name: "Swedish Krona",
    symbol: "kr",
    country: "Sweden",
    countryCode: "SE",
  },
  {
    code: "NOK",
    name: "Norwegian Krone",
    symbol: "kr",
    country: "Norway",
    countryCode: "NO",
  },
  {
    code: "DKK",
    name: "Danish Krone",
    symbol: "kr",
    country: "Denmark",
    countryCode: "DK",
  },
  {
    code: "PLN",
    name: "Polish Złoty",
    symbol: "zł",
    country: "Poland",
    countryCode: "PL",
  },
  {
    code: "THB",
    name: "Thai Baht",
    symbol: "฿",
    country: "Thailand",
    countryCode: "TH",
  },
  {
    code: "IDR",
    name: "Indonesian Rupiah",
    symbol: "Rp",
    country: "Indonesia",
    countryCode: "ID",
  },
  {
    code: "MYR",
    name: "Malaysian Ringgit",
    symbol: "RM",
    country: "Malaysia",
    countryCode: "MY",
  },
  {
    code: "PHP",
    name: "Philippine Peso",
    symbol: "₱",
    country: "Philippines",
    countryCode: "PH",
  },
  {
    code: "VND",
    name: "Vietnamese Dong",
    symbol: "₫",
    country: "Vietnam",
    countryCode: "VN",
  },
  {
    code: "AED",
    name: "UAE Dirham",
    symbol: "د.إ",
    country: "United Arab Emirates",
    countryCode: "AE",
  },
  {
    code: "SAR",
    name: "Saudi Riyal",
    symbol: "﷼",
    country: "Saudi Arabia",
    countryCode: "SA",
  },
  {
    code: "ILS",
    name: "Israeli New Shekel",
    symbol: "₪",
    country: "Israel",
    countryCode: "IL",
  },
  // Cryptocurrencies
  {
    code: "BTC",
    name: "Bitcoin",
    symbol: "₿",
    country: "Cryptocurrency",
    countryCode: "BTC",
  },
  {
    code: "ETH",
    name: "Ethereum",
    symbol: "Ξ",
    country: "Cryptocurrency",
    countryCode: "ETH",
  },
];
